import { render, staticRenderFns } from "./ShippingFilesModal.vue?vue&type=template&id=892f36a2&scoped=true&"
import script from "./ShippingFilesModal.vue?vue&type=script&lang=js&"
export * from "./ShippingFilesModal.vue?vue&type=script&lang=js&"
import style0 from "./ShippingFilesModal.vue?vue&type=style&index=0&id=892f36a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892f36a2",
  null
  
)

component.options.__file = "ShippingFilesModal.vue"
export default component.exports